import React from 'react';
import Icon from '../Icons/Icon';
import 'idempotent-babel-polyfill';

export default class CategoryDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resources: props.resources,
            showCategories: false
        };
        this.renderCategoryList = this.renderCategoryList.bind(this);
        this.renderCategory = this.renderCategory.bind(this);
        this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this);
        this.setDropdownRef = this.setDropdownRef.bind(this);
        this.getCurrentCategoryDescription = this.getCurrentCategoryDescription.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutsideDropdown);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutsideDropdown);
    }

    handleClickOutsideDropdown(e) {
        if (this.dropdownRef && !this.dropdownRef.contains(e.target)) {
            this.setState({ showCategories : false });
        }
    }
    
    setDropdownRef(node) {
        this.dropdownRef = node;
    }

    renderCategoryList(categories){
        return (
            <ul className="dropdown-menu">
                {categories.map(this.renderCategory)}
            </ul>
        );
    }


    renderCategory(category, i) {
        let categoryID = {
            categoryID: category.code
        }
        // if (category.depth && category.depth > 0) {
        //     var prefix = "";
        //     for (var i = 0; i < (category.depth || 0); i++) {
        //         prefix = prefix + "-";
        //     }
        //     category.description = prefix + category.description;
        // }
        return (
            <li key={i} className="category-wrapper clearfix" role="rowXXX">
                <a role="treeitemXXX" href="javascript:void(0);" title={category.description}  onClick={this.props.SearchCategories.bind(this, category)}>{category.description}</a>
            </li>
        );
    }
    getCurrentCategoryDescription(categoryCode, defaultValue){
        let result = defaultValue;
        for(var i in this.props.CategoryList){
            if(this.props.CategoryList[i].code == categoryCode)
                result = this.props.CategoryList[i].description;
        }
        return result;
    }

render() {
    return (
        <div id="category-select-area" className="clearfix" style={{display: "inline-block", padding: "0px 12px"}}>
                <div className="dropdown">
                    <button ref={this.setDropdownRef} onClick={() => this.setState({showCategories: !this.state.showCategories})} className="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
                    <span className="dropdown-placeholder">{this.getCurrentCategoryDescription(this.props.currentCategoryCode, this.props.resources["PWS.ProductCategory.Categories"])}</span>
                        <span className="caret"></span>
                    </button>
                        { this.state.showCategories ? this.renderCategoryList(this.props.CategoryList) : null }
            </div>
        </div>
        );
}
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/CategoryDropdown.js